import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { enumRoles, enumPermissions } from "data/enums/authorization";

import {
  selectAuthenticated,
  selectPermissions,
  selectRole,
} from '../../redux/slices/authSlice';

export const getHomeRoute = (role, permissions = []) => {
  let pathPrefix = ''
  let homeModulePath = 'home'

  switch (role) {
    case enumRoles.ADMIN: pathPrefix = 'admin'; break;
    case enumRoles.FINANCE: pathPrefix = 'admin'; break;
    case enumRoles.MANAGER: pathPrefix = 'admin'; break;
    case enumRoles.SUPPORT: pathPrefix = 'admin'; break;
    case enumRoles.USER: pathPrefix = 'user'; break;
    default: break;
  }

  if ([enumRoles.USER].includes(role)) homeModulePath = 'dashboard/overview'
  else if (permissions.includes(enumPermissions.ADMIN_DASHBOARD_REALTIME)) {
    homeModulePath = 'dashboard/overview'
  } else homeModulePath = 'home'

  return { pathPrefix, homeModulePath }

}

export const RequireAuth = ({ children }) => {
  let authenticated = useSelector(selectAuthenticated);
  let location = useLocation();

  if (!authenticated) {
    return <Navigate to="/admission/login" state={{ from: location }} />;
  }

  return children;
}

export const RequirePermission = ({ children, requiredPermission, requiredRoles }) => {
  const permissions = useSelector(selectPermissions);
  const role = useSelector(selectRole);
  const location = useLocation();

  let permissionValid = true;
  let roleValid = true;

  if (requiredPermission) {
    if (!permissions.includes(requiredPermission)) permissionValid = false
  }

  if (requiredRoles && Array.isArray(requiredRoles)) {
    if (!requiredRoles.includes(role)) roleValid = false
  }

  const { pathPrefix, homeModulePath } = getHomeRoute(role, permissions)
  let redirectLink = `/${pathPrefix}/${homeModulePath}/`

  if (!permissionValid || !roleValid) {
    console.log('Require permission2:', 'permissionValid', permissionValid, 'roleValid', roleValid)
    return <Navigate to={redirectLink} state={{ from: location }} />;
  }

  return children;
}

export const RedirectLoggedInUsers = ({ children }) => {
  let redirectLink = ''
  let location = useLocation();
  const role = useSelector(selectRole)
  const permissions = useSelector(selectPermissions);
  const { pathPrefix, homeModulePath } = getHomeRoute(role, permissions)
  redirectLink = role ? `/${pathPrefix}/${homeModulePath}/` : ''

  if (redirectLink) {
    return <Navigate to={redirectLink} state={{ from: location }} />;
  }
  return children
}

export const Redirect404 = () => {

  let location = useLocation();
  const role = useSelector(selectRole)
  const permissions = useSelector(selectPermissions);
  const { pathPrefix, homeModulePath } = useMemo(() => getHomeRoute(role, permissions), [permissions, role])
  const redirectLink = useMemo(() => role ? `/${pathPrefix}/${homeModulePath}/` : '/admission/login', [homeModulePath, pathPrefix, role])

  return <Navigate to={redirectLink} state={{ from: location }} />;

}